module.exports = __webpack_public_path__ + "media/images/EmailDownload-ae8ba248.svg";